import { useRouter } from '@/util/hook/custom';
import useEffect from '@/util/hook/useEffect';
import useSelector from '@/util/hook/useSelector';
import { selectLiffId } from '@/util/redux/auth';
import { APP } from '../../../config/app';
export default function AppInitProvider({ children }) {
    const _id = useSelector(selectLiffId);
    const { navigate } = useRouter();
    useEffect(() => {
        // #NOTES
        // we use '_id' to determine if the user is able to access the app
        if (_id) {
            // start of the app
            navigate(APP.ROUTES.MARKETING_CHANNEL);
        }
        else {
            throw new Error('_id is not found in AppInitProvider');
        }
    }, []);
    return children;
}
